import {eqProductStatus, ProductStatus} from '@services/model/product';
import {ApplicationResource} from '@services/resource/application-resource';
import {Cycle, eqCycle} from '@services/model/cycle';
import moment, {Moment} from 'moment';
import {Ord, ordNumber} from 'fp-ts/lib/Ord';
import {Eq} from 'fp-ts/lib/Eq';

export class Application {
  constructor(
    public readonly productStatus: ProductStatus,
    public readonly cycle: Cycle,
    public readonly approvalDate: Moment | undefined,
  ) {}

  static fromResource(r: ApplicationResource): Application {
    return new Application(r.productStatus, Cycle.fromResource(r.cycle), r.approvalDate ? moment(r.approvalDate) : undefined);
  }

  static fromResources(applications: ApplicationResource[]): Application[] {
    return applications ? applications.map((application) => this.fromResource(application)) : [];
  }
}

export const eqApplication: Eq<Application> = {
  equals: (x, y) => eqProductStatus.equals(x.productStatus, y.productStatus) && eqCycle.equals(x.cycle, y.cycle),
};

export const ordApprovalDate: Ord<Application> = {
  ...eqApplication,
  compare: (x: Application, y: Application) => {
    if (!x.approvalDate || !y.approvalDate) {
      return 0;
    }
    return ordNumber.compare(x.approvalDate.milliseconds(), y.approvalDate.milliseconds());
  },
};
